export default defineNuxtPlugin(() => {
	// 处理测试环境Iframe的事件 单页无法监听 todo 方便开发环境
	const EVENT_NAME = {};
	const postMessageIframe = (message: any) => {
		// window.postMessage(message, '*');
	};
	return {
		provide: { postMessageIframe },
	};
});
